import axios from 'axios';

const API_URL = 'https://plasticemployers.duckdns.org/api/';

// Configura um interceptor de resposta   https://plasticemployers.duckdns.org
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Remove o token do localStorage, se necessário
      localStorage.removeItem('access');
      localStorage.removeItem('user');
      // Redireciona para a página de login
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

// Função auxiliar para obter o header de autorização
const getAuthHeader = () => {
  const token = localStorage.getItem('access');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const login = (username, password) => {
  return axios.post(`${API_URL}token/`, { username, password });
};

export const getEmployees = () => {
  return axios.get(`${API_URL}employees/`, { headers: getAuthHeader() });
};

// Função para importar clientes do PHC (requisição protegida)
export const importClients = () => {
  return axios.post(`${API_URL}import-clients/`, {}, { headers: getAuthHeader() });
};

// Função para criar um cliente (requisição protegida)
export const createClient = (clientData) => {
  return axios.post(`${API_URL}clients/create/`, clientData, { headers: getAuthHeader() });
};

// Função para obter a lista de clientes (requisição protegida)
export const getClients = () => {
  return axios.get(`${API_URL}clients/`, { headers: getAuthHeader() });
};

// Função para criar uma família (CreateFamily)
export const createFamilia = (familiaData) => {
  return axios.post(`${API_URL}family/create/`, familiaData, { headers: getAuthHeader() });
};

// Função para listar os artigos sem família (para integrar)
export const getArticlesWithoutFamily = () => {
  return axios.get(`${API_URL}articles-without-family/`, { headers: getAuthHeader() });
};

// Função para integrar artigos a uma família
export const integrateFamily = (integrationData) => {
  // integrationData deve conter: { family_id, merchandise_ids: [...] }
  return axios.post(`${API_URL}integrate-family/`, integrationData, { headers: getAuthHeader() });
};

export const getFamilies = () => {
  return axios.get(`${API_URL}family/`, { headers: getAuthHeader() });
};

export const updateFamilia = (familyId, data) => {
  return axios.patch(`${API_URL}family/${familyId}/update/`, data, { headers: getAuthHeader() });
};

// Função para criar um artigo (Merchandise)
export const createMerchandise = (articleData) => {
  return axios.post(`${API_URL}merchandise/create/`, articleData, { headers: getAuthHeader() });
};

// Função para buscar artigos sem família filtrados por família
export const getMerchandiseByFamily = () => {
  return axios.get(`${API_URL}merchandise/by-family/`, { headers: getAuthHeader() });
};

// Função para buscar artigos filtrados por referência
export const getMerchandiseByReference = () => {
  return axios.get(`${API_URL}merchandise/by-reference/`, { headers: getAuthHeader() });
};

// Função para buscar artigos filtrados por fornecedor
export const getMerchandiseBySupplier = (supplierId) => {
  return axios.get(`${API_URL}merchandise/by-supplier/?supplier=${supplierId}`, { headers: getAuthHeader() });
};

// Função para importar artigos do PHC (requisição protegida)
export const importMerchandise = () => {
  return axios.post(`${API_URL}merchandise/import/`, {}, { headers: getAuthHeader() });
};

export const deleteMerchandise = (merchandiseId) => {
  return axios.delete(`${API_URL}merchandise/${merchandiseId}/`, { headers: getAuthHeader() });
};


//Supliers
export const getMerchandiseWithoutSupplier = (familyId) => {
  return axios.get(`${API_URL}merchandise/without-supplier/?family=${familyId}`, { headers: getAuthHeader() });
};
export const integrateSupplierProducts = (supplierId, data) => {
  // 'data' deve conter, por exemplo, { merchandise_ids: [1, 2, 3] }
  return axios.post(`${API_URL}supplier/integrate-products/`, { supplier_id: supplierId, ...data }, { headers: getAuthHeader() });
};
// Função para criar um fornecedor (requisição protegida)
export const createSupplier = (supplierData) => {
  return axios.post(`${API_URL}suppliers/`, supplierData, { headers: getAuthHeader() });
};

export const getSuppliers = () => {
  return axios.get(`${API_URL}suppliers/`, { headers: getAuthHeader() });
};

//ENTRADA

// Função para obter os finished products (Merchandise da família "finished_product")
export const getFinishedProducts = () => {
  return axios.get(`${API_URL}merchandise/finished-products/`, { headers: getAuthHeader() });
};

// Função para dar entrada (incrementar estoque) de um merchandise
export const darEntrada = (merchandiseId, data) => {
  return axios.post(`${API_URL}merchandise/${merchandiseId}/dar-entrada-rope/`, data, { headers: getAuthHeader() });
};

// Função para imprimir etiquetas para um merchandise
export const imprimirEtiquetas = (merchandiseId) => {
  return axios.post(`${API_URL}merchandise/${merchandiseId}/imprimir-etiquetas/`, {}, { headers: getAuthHeader() });
};

export const gerarEtiquetas = (data) => {
  return axios.post(`${API_URL}gerar-etiquetas/`, data, { headers: getAuthHeader() });
};


// Nova função para entrada de PackingBox utilizando o novo endpoint
export const darEntradaPackingBox = (merchandiseId, data) => {
  return axios.post(`${API_URL}packingbox/in/${merchandiseId}/`, data, { headers: getAuthHeader() });
};

// Função para buscar as opções de Packing Box (boxTypeOptions)
export const getPackingBoxOptions = () => {
  return axios.get(`${API_URL}packing-options/`, { headers: getAuthHeader() });
};


//Movimentos
export const getMovements = () => {
  return axios.get(`${API_URL}movements/`, { headers: getAuthHeader() });
};

export const darEntradaFinishedProduct = (productReference, data) => {
  return axios.post(`${API_URL}merchandise/dar-entrada/`, data, { headers: getAuthHeader() });
};

export const quickExit = (barcode) => {
  return axios.post(`${API_URL}quick-exit/`, { barcode }, { headers: getAuthHeader() });
};

export const searchMerchandise = (query) => {
  return axios.get(`${API_URL}merchandise/search/`, {
    params: { q: query },
    headers: getAuthHeader()
  });
};

export const getMerchandiseDetails = (barcode) => {
  return axios.post(`${API_URL}barcode-lookup/`, { barcode }, { headers: getAuthHeader() });
};

export const finishSaida = (payload) => {
  return axios.post(`${API_URL}finish-saida/`, payload, { headers: getAuthHeader() });
};


//Urlspara a api da dachser

export const criarExpedicao = (payload) => {
  return axios.post(`${API_URL}criar-expedicao/`, payload, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
  });
};

export const handleExpedicaoAction = (order_id, action) => {
  return axios.post(
    `${API_URL}expedicoes`, 
    { order_id, action }, 
    { headers: { 'Content-Type': 'application/json', ...getAuthHeader() } }
  );
};

export const getExpedicoes = () => {
  return axios.get(`${API_URL}expedicoes`, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeader() }
  });
};

export const getExpedicoesintransit = () => {
  return axios.get(`${API_URL}expedicoesintransit`, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeader() }
  });
};

export const handleExpedicaorefresh = (order_id) => {
  return axios.post(`${API_URL}expedicoesintransit`, { order_id }, { 
    headers: { 
      'Content-Type': 'application/json', 
      ...getAuthHeader() 
    } 
  });
};


export const getExpedicaoDetails = orderId => {
  const url = `${API_URL}expedicoes/${orderId}/`;
  return axios.get(url, { headers: getAuthHeader() });
};


export const handleManifestoPrint  = (payload) => {
  return axios.post(`${API_URL}manifesto/`, payload, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeader() }
  });
};

export const fetchManifesto = (date) =>
  axios.get(`${API_URL}manifesto/`, { params: { date } });




export const handleCreateOrcamento = (payload) => {
  return axios.post(`${API_URL}orcamento`, payload, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeader() }
  });
};


export const uploadClientEtiquetaExcel = (clientId, file) => {
  const formData = new FormData();
  formData.append('cliente_id', clientId);
  formData.append('excel_file', file);
  return axios.post(
    `${API_URL}clients/upload-excel/`,
    formData,
    { 
      headers: { 
        'Content-Type': 'multipart/form-data', 
        ...getAuthHeader() 
      } 
    }
  );
};

// **Nova função para download do Excel de etiquetas**
export const downloadClientEtiquetaExcel = (clientId) => {
  return axios.get(
    `${API_URL}clients/download-excel/`,
    {
      params: { cliente_id: clientId },
      responseType: 'blob',
      headers: getAuthHeader()
    }
  );
};

export const gerarEtiquetas2 = (data) => {
  return axios.post(`${API_URL}gerar-etiquetas2/`, data, { headers: getAuthHeader() });
};
